// src/theme.js
import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const themeChakra = extendTheme({
  config: {
    initialColorMode: "system",
    useSystemColorMode: true,
  },
  styles: {
    global: (props) => ({
      "html, body, #root": {
        bg: mode("white", "gray.900")(props),
        color: mode("gray.800", "whiteAlpha.900")(props),
        width: "100%",
        height: "100%",
        margin: 0,
        padding: 0,
      },
    }),
  },
});

export default themeChakra;
